'use client';

import React, { useEffect, useState } from 'react';
import { CSSProperties } from 'react';
import * as S from './styles';

import Heading from '../../atoms/Heading';
import { useHomeData } from '@/hooks/useHomeData';
import { listarProdutos } from '@/services/marketplaceService';
import ListagemCategorias from '@/components/organisms/ListagemCategorias';
import ListagemProdutosHome from '@/components/organisms/ListagemProdutosHome';
import useBreakpoint from '@/hooks/useBreakpoint';
import { registrarEvento } from '@/services/googleAnalytics';

export type ListagemCreditosHomeProps = {
  style?: CSSProperties;
};

export default function ListagemCreditosHome(props: ListagemCreditosHomeProps) {
  const { style } = props;
  const { breakpoint } = useBreakpoint();
  const { categorias, produtos } = useHomeData();

  const [carregandoProdutosFiltrados, setCarregandoProdutosFiltrados] =
    useState(false);

  const [categoriaSelecionada, setCategoriaSelecionada] = useState(0);
  const [produtosFiltrados, setProdutosFiltrados] = useState(produtos);

  useEffect(() => {
    setProdutosFiltrados(produtos);
  }, [produtos]);

  async function buscarProdutosDeterminadaCategoria(categoriaNome: string) {
    if (categoriaNome === 'Todos') {
      setCarregandoProdutosFiltrados(false);
      setProdutosFiltrados(produtos);
      return;
    }

    try {
      setCarregandoProdutosFiltrados(true);
      const buscaProdutoDeterminadaCategoria = await listarProdutos({
        filtros: `categoria.nome.Contains("${categoriaNome}") && somenteBeneficio == false`,
      });
      setProdutosFiltrados(buscaProdutoDeterminadaCategoria);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /* empty */
    } finally {
      setCarregandoProdutosFiltrados(false);
    }
  }

  return (
    <S.Container style={style} $breakpoint={breakpoint}>
      <S.ContainerTextos $breakpoint={breakpoint}>
        <Heading
          $priority={2}
          $size={6}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text="Produtos disponíveis"
        />
      </S.ContainerTextos>

      <S.ContainerListagens $breakpoint={breakpoint}>
        <ListagemCategorias
          $key="categoria_listagem"
          $categoriaSelecionada={categoriaSelecionada}
          $categorias={categorias || []}
          $funcaoCliqueCategoria={({ categoria, index }) => {
            registrarEvento('home_clicou_categoria', {
              categoriaID: categoria?.marketPlaceCategoriaID,
              categoria: categoria.nome,
            });
            setCategoriaSelecionada(index);
            buscarProdutosDeterminadaCategoria(categoria.nome);
          }}
        />

        <ListagemProdutosHome
          $loading={carregandoProdutosFiltrados}
          $produtos={produtosFiltrados}
        />
      </S.ContainerListagens>
    </S.Container>
  );
}
